import React from "react";
import { FaSchool, FaUserCheck, FaShoppingCart } from "react-icons/fa";

function Work() {
  const steps = [
    {
      id: 1,
      title: "School Registration",
      desc: "Schools register and receive a unique code to share with parents. Set up your store in minutes.",
      icon: <FaSchool />,
      color: "#097969"
    },
    {
      id: 2,
      title: "Parent Access",
      desc: "Parents enter the school code to access the exclusive store with curated items for their children.",
      icon: <FaUserCheck />,
      color: "#097969"
    },
    {
      id: 3,
      title: "Easy Shopping",
      desc: "Browse, select sizes, and purchase. Items are delivered directly to your doorstep or school.",
      icon: <FaShoppingCart />,
      color: "#097969"
    }
  ];

  return (
    <section className="work-section py-5 bg-white">
      <div className="container py-lg-5">
        <div className="text-center mb-5">
          <h2 className="display-6 fw-bold">How It Works</h2>
          <p className="text-muted">Hover over the steps to learn more</p>
        </div>

        <div className="row g-4">
          {steps.map((step) => (
            <div className="col-lg-4 col-md-6" key={step.id}>
              <div className="work-card">
                <div className="content-wrap">
                  <div className="icon-box" style={{ backgroundColor: step.color }}>
                    {step.icon}
                  </div>
                  <h4 className="fw-bold my-3">{step.title}</h4>
                  
                  {/* Ye portion hover par dikhega */}
                  <div className="reveal-text">
                    <p className="mb-0 text-muted">{step.desc}</p>
                  </div>
                </div>
                <div className="step-badge">{step.id}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>
        {`
          .work-card {
            background: #ffffff;
            padding: 40px 30px;
            border-radius: 20px;
            text-align: center;
            border: 1px solid #eee;
            position: relative;
            overflow: hidden; /* Bahar jata text hide karne ke liye */
            height: 300px; /* Ek fixed height zaroori hai animation ke liye */
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.5s ease;
            cursor: pointer;
          }

          .work-card:hover {
            border-color: #097969;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          }

          .content-wrap {
            transition: transform 0.5s ease;
          }

          /* Default state: Text niche chhupa hua aur invisible */
          .reveal-text {
            opacity: 0;
            max-height: 0;
            transform: translateY(20px);
            transition: all 0.5s ease;
            margin-top: 0;
          }

          /* Hover state: Content upar move hoga aur text dikhega */
          .work-card:hover .content-wrap {
            transform: translateY(-20px);
          }

          .work-card:hover .reveal-text {
            opacity: 1;
            max-height: 100px; /* Description ki length ke hisaab se */
            transform: translateY(0);
            margin-top: 15px;
          }

          .icon-box {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            color: white;
            font-size: 28px;
            transition: all 0.5s ease;
          }

          .work-card:hover .icon-box {
            transform: scale(0.9);
          }

          .step-badge {
            position: absolute;
            top: 15px;
            left: 20px;
            font-size: 14px;
            font-weight: bold;
            color: #097969;
            background: #f0faf7;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        `}
      </style>
    </section>
  );
}

export default Work;